import {createPinia} from 'pinia';

export const pinia = createPinia();

export function registerPinia({app}: {app: import('vue').App}) {
  app.use(pinia);

  return {
    pinia,
  };
}
